import { getFormattedSlug } from '@src/pages/[...slug]/components/collection/utils'

import { ContentfulExperimentConfig } from '../ContentfulExperimentConfig'

import ContentfulImage from './ContentfulImage'

export interface IContentfulLink {
  id: string
  text: string
  subText?: ContentfulSubText | null
  entry?: ContentfulEntry | null
  logo?: ContentfulImage
  url?: string | null
  scrollToHash?: string | null
  slug?: string | null
  textColor?: string | null
  experimentConfig?: ContentfulExperimentConfig[]
}

interface ContentfulSubText {
  raw: string
}
interface ContentfulEntry {
  name?: string | null
  slug: string
}

export default class ContentfulLink implements IContentfulLink {
  readonly id: string
  readonly text: string
  readonly logo?: ContentfulImage
  readonly subText?: ContentfulSubText | null
  readonly entry?: ContentfulEntry | null
  readonly url?: string | null
  readonly slug?: string | null
  readonly scrollToHash?: string | null
  readonly textColor?: string | null
  experimentConfig?: ContentfulExperimentConfig[]

  constructor({ text, subText, entry, url, slug, id, logo, textColor, experimentConfig }: IContentfulLink) {
    this.id = id
    this.text = text
    this.subText = subText
    this.entry = entry
    this.url = url
    this.slug = slug
    this.scrollToHash = slug
    this.textColor = textColor
    this.logo = logo
    this.experimentConfig = experimentConfig
    return {
      ...this,
    }
  }

  static getLinkPath = (link: ContentfulLink) => {
    if (!link) return '/'
    if (link.entry?.slug) return `/${getFormattedSlug(link.entry.slug)}`
    if (link.slug) return `/${getFormattedSlug(link.slug)}`
    if (link.url) return link.url
    return '/'
  }
}
